export default class MobileMenu {
  constructor() {
    this.getDomElements()

    if (!this.dom.menu || !this.dom.trigger || !this.dom.header) return
    this.init()
  }

  init() {
    this.handleClick()
  }

  handleClick() {
    this.dom.trigger.addEventListener('click', () => {
      this.dom.header.classList.toggle('is-mobile')
      this.dom.trigger.classList.toggle('is-active')
      this.dom.menu.classList.toggle('is-active')
    })
  }

  getDomElements() {
    return this.dom = {
      'menu' : document.querySelector('.js-mobile-menu'),
      'trigger' : document.querySelector('.js-mobile-trigger'),
      'header' : document.querySelector('.js-header')
    }
  }
}